import { SearchFilter, SearchFilterOptionRange } from "../../../redux-magic/sub-interfaces/search-types";

export const _h_bedrooms: SearchFilter = {
	id: "bedrooms",
	title: "Bedrooms",
	level: 3,
	index: 7,
	presentation_type: "checkboxes",
	multi: true,
	affects: [],
	affected_by: ["property_type"],
	priority: 3,
	is_advanced: false,
	included_in_search_bar: true,
	option_type: "range",
	possible_options: [
		{
			id: "bedrooms",
			title: "Bedrooms",
			value: {
				min: 0,
				max: 0,
				unlock_max: true,
			},
		},
	] as Array<SearchFilterOptionRange>,
	active_options: [
		{
			id: "bedrooms",
			title: "Bedrooms",
			value: {
				min: 0,
				max: 0,
				unlock_max: true,
			},
		},
	] as Array<SearchFilterOptionRange>,
	selected_options: [] as Array<SearchFilterOptionRange>,
	db_collection: "properties",
	db_field: "bhk",
	is_visible: true,
	is_applied: false,
	is_accordion_open: true,
};
